import React from 'react'

import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'

export default class ImageSlider extends React.Component {
  render () {
    return (
      <Carousel
        infiniteLoop
        autoPlay
        showArrows={false}
        showStatus={false}
        showThumbs={false}
        interval={4200}
        transitionTime={600}
      >
        <div>
          <img src={require('./tiefe-lagen-kugel.svg')} />
        </div>
        <div>
          <img src={require('./mittlere-lagen-kugel.svg')} />
        </div>
        <div>
          <img src={require('./hohe-lagen-kugel.svg')} />
        </div>
      </Carousel>
    )
  }
}
